module.exports = __webpack_public_path__ + "img/action-F.be695034.svg";